import { render, staticRenderFns } from "./CancellationStageStatus.vue?vue&type=template&id=70acf320&"
import script from "./CancellationStageStatus.vue?vue&type=script&lang=js&"
export * from "./CancellationStageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports